import React, { Suspense, useMemo } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import rootRoutes from '../router';
import { parseQuery } from '../../core/helpers/parseQuery';
import { DefaultQueryParams } from '../../core/constants/defaultQueryParams';

function DefaultRoutes({ contentType, ...props }) {
  const { search } = useLocation();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);

  const defaultRedirectComponentPath = useMemo(() => {
    return `${rootRoutes.find((item) => item.gameId === +gameId)?.path}${search}`;
  }, [search, gameId]);

  return (
    <Routes>
      {rootRoutes.map((route) => {
        const Component = route[contentType];
        return (
          <Route
            exact={route.exact}
            key={route.path}
            path={route.path}
            element={
              <Suspense fallback={<div />}>
                <Component {...props} />
              </Suspense>
            }
          />
        );
      })}
      <Route exact path='*' element={<Navigate to={defaultRedirectComponentPath} />} />
    </Routes>
  );
}

export default DefaultRoutes;
